export enum ApiExpensesField {
  ExpenseLabel = 'expense_label',
  ExpensePaymentType = 'expense_payment_type',
  NbExpenses = 'nb_expenses',
  SumExpenseTaxAmount = 'sum_expense_tax_amount',
  SumExpenseTaxExcluded = 'sum_expense_tax_excluded',
  SumExpenseTaxIncluded = 'sum_expense_tax_included',
}

export enum ApiExpensesAggregate {
  Label = 'label',
  PaymentType = 'paymentType',
}
